/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Unterkünfte ansehen`
};

const en_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `See accommodations`
};

const es_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ver el alojamiento`
};

const fr_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Voir les hébergements`
};

const it_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Vedere l'alloggio`
};

const nl_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Bekijk de accommodatie`
};

const pt_route_zoi_hotel__cta_label = /** @type {(inputs: {}) => string} */ () => {
	return `Ver o alojamento`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__cta_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_zoi_hotel__cta_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_zoi_hotel__cta_label", locale)
	if (locale === "de") return de_route_zoi_hotel__cta_label(inputs)
	if (locale === "en") return en_route_zoi_hotel__cta_label(inputs)
	if (locale === "es") return es_route_zoi_hotel__cta_label(inputs)
	if (locale === "fr") return fr_route_zoi_hotel__cta_label(inputs)
	if (locale === "it") return it_route_zoi_hotel__cta_label(inputs)
	if (locale === "nl") return nl_route_zoi_hotel__cta_label(inputs)
	return pt_route_zoi_hotel__cta_label(inputs)
};